import { render, staticRenderFns } from "./OldBrowserDialog.vue?vue&type=template&id=6d8768a4&scoped=true&"
import script from "./OldBrowserDialog.vue?vue&type=script&lang=ts&"
export * from "./OldBrowserDialog.vue?vue&type=script&lang=ts&"
import style0 from "./OldBrowserDialog.vue?vue&type=style&index=0&id=6d8768a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8768a4",
  null
  
)

export default component.exports